import {GroupBase, StylesConfig} from 'react-select';

const fontFamilty = '"Poppins", sans-serif';

enum Color {
  RED = '#F56565',
  BLUE = '#4376fb',
  GRAY = '#E2E8F0',
  LILY = '#E3E8FC',
  DARK_GRAY = '#646464',
  WHITE = '#FFF',
  BLACK = '#000',
}

export const getSelectStyles = (
  error?: boolean,
  noMarginBottom?: boolean
): StylesConfig<unknown, boolean, GroupBase<unknown>> => ({
  container: (styles) => ({
    ...styles,
    height: 'inherit',
  }),
  control: (styles, {isFocused}) => ({
    ...styles,
    fontFamily: fontFamilty,
    backgroundColor: 'transparent',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    height: '2.75rem',
    maxHeight: '2.75rem',
    minHeight: '38px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '0.5rem',
    borderOpacity: 1,
    borderColor: error ? Color.RED : isFocused ? Color.BLUE : Color.GRAY,
    display: 'flex',
    alignItems: 'center',
    ':hover': {
      borderColor: error ? Color.RED : isFocused ? Color.BLUE : Color.GRAY,
    },
    marginBottom: noMarginBottom ? 0 : '0.75rem',
  }),
  valueContainer: (styles) => ({
    ...styles,
    maxHeight: '2.75rem',
  }),
  input: (styles) => ({
    ...styles,
    maxHeight: '2.75rem',
    margin: '2px',
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    maxHeight: '2.75rem',
  }),
  placeholder: (styles) => ({
    ...styles,
    fontFamily: fontFamilty,
    fontSize: '1rem',
    maxHeight: '2.75rem',
    color: '#a0aec0',
  }),
  option: (styles, {isDisabled, isFocused, isSelected}) => ({
    ...styles,
    backgroundColor: isSelected ? Color.BLUE : isFocused ? Color.LILY : 'transparent',
    color: isSelected ? Color.WHITE : isFocused ? Color.BLACK : Color.BLACK,
    cursor: isDisabled ? 'not-allowed' : 'default',
    fontFamily: fontFamilty,
    fontSize: '1rem',
    lineHeight: '1.25rem',
    ':active': {
      ...styles[':active'],
      backgroundColor: Color.LILY,
      color: Color.BLACK,
    },
  }),
  multiValue: (styles) => ({
    ...styles,
    color: Color.BLUE,
    backgroundColor: Color.LILY,
    borderRadius: '0.25rem',
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: Color.BLUE,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    fontWeight: 500,
    fontFamily: fontFamilty,
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: Color.BLUE,
    backgroundColor: Color.GRAY,
  }),
});
